import { CommonModule } from '@angular/common'
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { PlayerBetDto, SeatDto } from '@core/dtos'
import { ModeEnum } from '@core/enums'
import { GameHttp } from '@core/https'
import { WebSocketService } from '@core/services'
import { TabNamesEnums } from '@rush-shared/enums'
import { TabModel } from '@rush-shared/models'
import { ClassicService, RushMainService, RushPopupService } from '@rush-shared/services'
import { TimerV2Component } from '@shared/components'
import { PlayerService } from '@shared/services'
import { environment } from '@src/environments/environment'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-stream',
  standalone: true,
  imports: [CommonModule, TimerV2Component],
  templateUrl: './stream.component.html',
  styleUrl: './stream.component.sass',
})
export class StreamComponent implements OnInit, OnDestroy {
  @ViewChild('playerVideoContainer', { static: false }) playerVideoContainer: ElementRef

  private readonly _subscription = new Subscription()

  get playerBetResult(): PlayerBetDto | undefined {
    return this._playerService.playerBetResult
  }
  get clientHeight(): number {
    return this.playerVideoContainer?.nativeElement.clientHeight || 0
  }
  get clientWidth(): number {
    return this.playerVideoContainer?.nativeElement.clientWidth || 0
  }

  mode: ModeEnum
  modeType = ModeEnum
  currentSeat?: SeatDto
  countdown: number
  dealerId: string
  tabNamesEnums = TabNamesEnums
  activeTab: TabModel
  loaded = false
  streamName = environment.nanoStream.classicStreamName

  constructor(
    public _playerService: PlayerService,
    public _rushPopupService: RushPopupService,
    private _webSocketService: WebSocketService,
    private _gameHttp: GameHttp,
    private _classicService: ClassicService,
    private _rushMainService: RushMainService,
    public _sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this._rushMainService.activeTab$.observer.subscribe((activeTab) => {
      this.activeTab = activeTab
      // this.loaded = this.loaded || activeTab.name === TabNamesEnums.CLASSIC
    })

    this._playerService.currentSeat$.subscribe((i) => {
      this.currentSeat = i
    })

    this._subscription.add(
      this._classicService.activeDealer$.subscribe((dealer) => {
        this.dealerId = dealer.id

        this._gameHttp.getCurrentConfig(dealer.id).subscribe((i) => {
          this.mode = i.mode
        })

        this._webSocketService.listenToMode(dealer.id, ({ mode }) => {
          this.mode = mode
        })

        this._webSocketService.listenToCountdown(dealer.id, (timeRemaining: number) => {
          this.countDownCallback(timeRemaining)
        })
      }),
    )

    this._subscription.add(
      this._playerService.playerBetResult$.subscribe((result) => {
        if (result?.isWinner === true) {
          this._rushPopupService.setTitle('Congratulation!')
          this._rushPopupService.setMessage(
            '+' + this.playerBetResult?.earnedChips?.toFixed(2) || '',
          )
        } else if (
          result?.isWinner === false ||
          result?.isWinner === null ||
          result?.isWinner === undefined
        ) {
          this._rushPopupService.setTitle('Better luck next time!')
          this._rushPopupService.setMessage(
            'Lost coins ' + this.playerBetResult?.earnedChips?.toFixed(2) || '',
          )
          this._rushPopupService.showDangerPopup()
        }
      }),
    )
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe()
    this._webSocketService.removeModeListener(this.dealerId)
    this._webSocketService.removeCountdownListener(this.dealerId)
  }

  private countDownCallback(timeRemaining: number) {
    this.countdown = timeRemaining
    this._classicService.setCountdown(timeRemaining)
  }
}
